import router from '@/router';

/**
 * Handles failed resource load (e.g. edit by id): alert + redirect on 404.
 * Consumes the rejection so webpack/vue do not show an uncaught overlay.
 */
export function handleResourceLoadError(dispatch, error, listRouteName) {
  dispatch('activeAlert', {
    message: (error && error.message) || 'Request failed',
    theme: 'danger',
  });

  if (error && Number(error.status) === 404 && listRouteName) {
    router.push({ name: listRouteName });
  }
}
